import { useEffect, useRef } from 'react';
import { api } from '../services/api';

/**
 * ZYN-64 — Pede permissão de notificação push e registra a subscription no servidor.
 * Chame uma vez em Layout.jsx após login. É idempotente — registra endpoint só se mudou.
 */
export function usePushNotifications(user) {
  const registeredRef = useRef(false);

  useEffect(() => {
    if (!user || registeredRef.current) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    // Pede permissão apenas se não concedida/negada ainda
    if (Notification.permission === 'denied') return;

    async function subscribe() {
      try {
        // Busca a VAPID public key do servidor
        const { publicKey } = await api.getVapidPublicKey();
        if (!publicKey) return;

        const reg = await navigator.serviceWorker.ready;

        // Converte a chave VAPID de base64url para Uint8Array
        const vapidKey = urlBase64ToUint8Array(publicKey);

        let sub = await reg.pushManager.getSubscription();
        if (!sub) {
          // Pede permissão ao usuário
          const perm = await Notification.requestPermission();
          if (perm !== 'granted') return;

          sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: vapidKey,
          });
        }

        // Envia subscription ao servidor
        await api.subscribePush(sub.toJSON());
        registeredRef.current = true;
      } catch (err) {
        console.warn('[Push] Falha ao registrar subscription:', err.message);
      }
    }

    // Pequeno delay para não competir com login
    const t = setTimeout(subscribe, 3000);
    return () => clearTimeout(t);
  }, [user?.id]);
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return new Uint8Array([...raw].map(c => c.charCodeAt(0)));
}
